import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Alooma from 'services/alooma';
import useInitHotJar from 'services/useInitHotJar';
import useSetCjeInCookies from 'hooks/useSetCjeInCookies';
import useGoogleTagManager from 'hooks/useGoogleTagManager';
import { BSS_PATHS, PATHS } from 'consts/paths';
import useProcessMarketingParamsOnPublicPage from 'hooks/useProcessMarketingParamsOnPublicPage';
import matchBssPathWithAloomaSource from 'functions/matchBssPathWithAloomaSource';
import { Iframe } from './BssPageWithRoute.style';

const BssPage = ({ location }) => {
  const pageSearch = location.search || '';
  const pagePathname = location.pathname || '';

  useInitHotJar();
  useSetCjeInCookies();
  useGoogleTagManager();
  useProcessMarketingParamsOnPublicPage();
  Alooma.usePageViewTracker(matchBssPathWithAloomaSource(pagePathname));

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nocache" />
        <link rel="preconnect" href={PATHS.BSS_ORIGINAL} />
      </Helmet>
      <Iframe
        title="Karma"
        src={`${PATHS.BSS_ORIGINAL}${pagePathname}${pageSearch}`}
        allow="identity-credentials-get"
        frameBorder="0"
      />
    </>
  );
};

// BSS - bestshoppingsecrets.com
export const BssPageWithRoute = () => {
  return (
    <Switch>
      <Route exact path={BSS_PATHS} render={props => <BssPage {...props} />} />
    </Switch>
  );
};
